var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-table',{attrs:{"data":_vm.revenuesData,"columns":_vm.revenuesColumns,"default-sort":"shoppingCenterGroupName","default-sort-direction":"asc"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }